import React, { useState } from 'react';

import styled from 'styled-components';
import palette from '../../lib/styles/palette';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import client, { url } from '../../lib/api/client';
import qs from 'qs';
import SettingCard, { SettingInfoBox, SettingInfoLabel, SettingInfoValue, CardFooter, SaveButton } from './SettingCard';

const DoorModal = styled.div`
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`;
const Background = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .35);
  z-index: -1;
`;

const ModalBox = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 600px;
  background-color: #fff;
  overflow: hidden;
  border-radius: .2rem;

  @media screen and (max-width: 720px) {
      position: absolute;
      top: 180px;
  }
`;
const ModalTitle = styled.div`
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  padding-left: 30px;
  background-color: ${palette.webCyan[5]};
  color: #fff;
  font-size: 1.3rem;
  font-weight: bold;
  border-top-left-radius: .2rem;
  border-top-right-radius: .2rem;
`;

const ModalList = styled.div`
  width: 100%;
  box-sizing: border-box;
  height: 300px;
  display: flex;
  flex-direction: column;
  padding: 24px 30px;
  overflow-y: auto;
`;

const ModalListItem = styled.div`
  padding: 12px 8px;
  border-bottom: 1px solid #e0e4ea;
  color: #555;
  font-size: 0.95rem;
  text-align: left;

  &:last-child {
    border-bottom: none;
  }
`;

const ActiveSection = styled.div`
  width: 100%;
  background: #f8f9fb;
  border: 1px solid #e0e4ea;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 16px;
`;

const Toolbar = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
`;

const OutlineButton = styled.button`
  border: 1px solid ${palette.webCyan[5]};
  border-radius: 6px;
  background: #fff;
  color: ${palette.webCyan[5]};
  padding: 10px 20px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: ${palette.webCyan[5]};
    color: #fff;
  }
`;

const GhostButton = styled.button`
  border: 1px solid #e0e4ea;
  border-radius: 6px;
  background: #fff;
  color: #868e96;
  padding: 10px 20px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    border-color: ${palette.webCyan[5]};
    color: ${palette.webCyan[5]};
  }
`;

const DangerButton = styled.button`
  border: 1px solid #e74c3c;
  border-radius: 6px;
  background: #fff;
  color: #e74c3c;
  padding: 8px 16px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: #e74c3c;
    color: #fff;
  }
`;

const ItemCard = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  padding: 24px;
  background: #fff;
  border: 1px solid #e0e4ea;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

  &:last-child {
    margin-bottom: 0;
  }
`;

const ItemRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding-bottom: 14px;

  &:last-of-type {
    padding-bottom: 0;
  }
`;

const ItemLabel = styled.div`
  width: 150px;
  min-width: 150px;
  font-size: 0.95rem;
  font-weight: 600;
  color: #555;
`;

const ItemField = styled.div`
  flex: 1;
`;

const TextInput = styled.input`
  width: 300px;
  max-width: 100%;
  border: 1px solid ${palette.inputBorder || '#CDD9ED'};
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 0.95rem;
  color: #2c3e50;
  transition: border-color 0.15s ease;

  &:focus {
    outline: none;
    border-color: ${palette.inputBorderFocus || '#275EFE'};
  }
`;

const ItemFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
`;

const ItemList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const AdminClubDoorInfo = ({
    selectClubInfo,
    setDoorActiveFlag,
    setFaceActiveFlag,
    setQRActiveFlag,
    setChangeDoorInfo,
    onChangeDoorInfos,
    onChangeDoorDeviceInfos,
    socketKey,
}) => {

    const [showDoorId, setShowDoorId] = useState(false)
    const [showDoorGroupId, setShowDoorGroupId] = useState(false)
    const [doorIDList, setDoorIDList] = useState([])
    const [doorGroupIdList, setDoorGroupIdList] = useState([])

    const onChangeDoorActiveFlag = (e)=>{
        setDoorActiveFlag(parseInt(e.target.value))
    }

    const onChangeFaceActiveFlag = (e)=>{
        setFaceActiveFlag(parseInt(e.target.value))
    }

    const onChangeQRActiveFlag = (e)=>{
        setQRActiveFlag(parseInt(e.target.value))
    }

    const setDoorName = (value, index)=>{
        let doorInfos = [...selectClubInfo.clubDoorInfos]
        doorInfos[index].name = value
        onChangeDoorInfos(doorInfos)
    }

    const setDoorId = (value, index)=>{
        let doorInfos = [...selectClubInfo.clubDoorInfos]
        doorInfos[index].doorid = parseInt(value)
        onChangeDoorInfos(doorInfos)
    }

    const setDoorGroupId = (value, index)=>{
        let doorInfos = [...selectClubInfo.clubDoorInfos]
        doorInfos[index].id = parseInt(value)
        onChangeDoorInfos(doorInfos)
    }

    const setDoorDevice = (value, index)=>{
        let clubDoorDeviceInfos = [...selectClubInfo.clubDoorDeviceInfos]
        clubDoorDeviceInfos[index] = parseInt(value)
        onChangeDoorDeviceInfos(clubDoorDeviceInfos)
    }

    const onClickAddDoor = ()=>{
        let doorInfos = [...selectClubInfo.clubDoorInfos]
        doorInfos.push({name: '', doorid: 0, id: 0})
        onChangeDoorInfos(doorInfos)
    }

    const onClickAddDoorDevice = ()=>{
        let clubDoorDeviceInfos = [...selectClubInfo.clubDoorDeviceInfos]
        clubDoorDeviceInfos.push('')
        onChangeDoorDeviceInfos(clubDoorDeviceInfos)
    }

    const onClickDeleteDoor = (index)=>{
        let doorInfos = [...selectClubInfo.clubDoorInfos]
        doorInfos.splice(index, 1)
        onChangeDoorInfos(doorInfos)
    }

    const onClickDeleteDoorDevice = (index)=>{
        let clubDoorDeviceInfos = [...selectClubInfo.clubDoorDeviceInfos]
        clubDoorDeviceInfos.splice(index, 1)
        onChangeDoorDeviceInfos(clubDoorDeviceInfos)
    }

    const loadDoorId = async ()=>{
        let res = await client.get(`${url}/api/clubs/club/doorid/${selectClubInfo.clubID}?${qs.stringify({socketKey})}`)
        setDoorIDList(res.data)
        setShowDoorId(true)
    }

    const loadDoorGroupId = async ()=>{
        let res = await client.get(`${url}/api/clubs/club/doorgroupid/${selectClubInfo.clubID}?${qs.stringify({socketKey})}`)
        setDoorGroupIdList(res.data)
        setShowDoorGroupId(true)
    }

  return (
    <>
        {
            showDoorId?
            <DoorModal>
                <Background onClick={() =>{
                    setShowDoorId(false)
                }}
                />
                <ModalBox>
                    <ModalTitle>출입문 아이디 목록</ModalTitle>
                    <ModalList>
                    {
                        doorIDList.map((item, index)=>{
                            return (
                                <ModalListItem key={`doorIDList_${index}`}>
                                    {item.name}  [ {item.doorID} ]
                                </ModalListItem>
                            )
                        })
                    }
                    </ModalList>
                </ModalBox>
            </DoorModal>
            :null
        }
        {
            showDoorGroupId?
            <DoorModal>
                <Background onClick={() =>{
                    setShowDoorGroupId(false)
                }}
                />
                <ModalBox>
                    <ModalTitle>출입 그룹 아이디 목록</ModalTitle>
                    <ModalList>
                    {
                        doorGroupIdList.map((item, index)=>{
                            return (
                                <ModalListItem key={`doorGroupIdList_${index}`}>
                                    {item.name}  [ {item.doorID} ]
                                </ModalListItem>
                            )
                        })
                    }
                    </ModalList>
                </ModalBox>
            </DoorModal>
            :null
        }
        {
            selectClubInfo?
            <SettingCard title="출입문 설정">
                <SettingInfoBox>
                    <SettingInfoLabel>활성화 유무</SettingInfoLabel>
                    <SettingInfoValue>
                        <RadioGroup
                            aria-label="type"
                            name="viewType"
                            value={selectClubInfo.attendActive}
                            onChange={onChangeDoorActiveFlag}
                            row={true}
                        >
                            <FormControlLabel
                                value={1}
                                control={<Radio color="primary" />}
                                label="활성화"
                            />
                            <FormControlLabel
                                value={0}
                                control={<Radio color="primary" />}
                                label="비활성화"
                            />
                        </RadioGroup>
                    </SettingInfoValue>
                </SettingInfoBox>
                {
                    selectClubInfo.attendActive == 1 ?
                    <ActiveSection>
                    <SettingInfoBox>
                        <SettingInfoLabel>QR인식 유무</SettingInfoLabel>
                        <SettingInfoValue>
                            <RadioGroup
                                aria-label="type"
                                name="viewType"
                                value={selectClubInfo.qrActive}
                                onChange={onChangeQRActiveFlag}
                                row={true}
                            >
                                <FormControlLabel
                                    value={1}
                                    control={<Radio color="primary" />}
                                    label="활성화"
                                />
                                <FormControlLabel
                                    value={0}
                                    control={<Radio color="primary" />}
                                    label="비활성화"
                                />
                            </RadioGroup>
                        </SettingInfoValue>
                    </SettingInfoBox>
                        <SettingInfoBox>
                            <SettingInfoLabel>얼굴인식 유무</SettingInfoLabel>
                            <SettingInfoValue>
                                <RadioGroup
                                    aria-label="type"
                                    name="viewType"
                                    value={selectClubInfo.faceActive}
                                    onChange={onChangeFaceActiveFlag}
                                    row={true}
                                >
                                    <FormControlLabel
                                        value={1}
                                        control={<Radio color="primary" />}
                                        label="활성화"
                                    />
                                    <FormControlLabel
                                        value={0}
                                        control={<Radio color="primary" />}
                                        label="비활성화"
                                    />
                                </RadioGroup>
                            </SettingInfoValue>
                        </SettingInfoBox>
                        <SettingInfoBox alignTop>
                            <SettingInfoLabel>출입문 장치 설정</SettingInfoLabel>
                            <SettingInfoValue style={{flexDirection: 'column', alignItems: 'flex-start'}}>
                                <Toolbar>
                                    <OutlineButton onClick={() => onClickAddDoor()}>
                                        + 출입문 장치 추가
                                    </OutlineButton>
                                    <GhostButton onClick={() => loadDoorId()}>
                                        출입문 아이디 보기
                                    </GhostButton>
                                    <GhostButton onClick={() => loadDoorGroupId()}>
                                        출입 그룹 아이디 보기
                                    </GhostButton>
                                </Toolbar>
                                <ItemList>
                                    {
                                        selectClubInfo.clubDoorInfos.map((item, index)=>{
                                            return (
                                                <ItemCard key={`clubDoorInfos_${index}`}>
                                                    <ItemRow>
                                                        <ItemLabel>{'이름'}</ItemLabel>
                                                        <ItemField><TextInput value={item.name} onChange={(e) => setDoorName(e.target.value, index)} type="text"/></ItemField>
                                                    </ItemRow>
                                                    <ItemRow>
                                                        <ItemLabel>{'출입문 아이디'}</ItemLabel>
                                                        <ItemField><TextInput value={item.doorid} onChange={(e) => setDoorId(e.target.value, index)} type="text"/></ItemField>
                                                    </ItemRow>
                                                    <ItemRow>
                                                        <ItemLabel>{'출입그룹 아이디'}</ItemLabel>
                                                        <ItemField><TextInput value={item.id} onChange={(e) => setDoorGroupId(e.target.value, index)} type="text"/></ItemField>
                                                    </ItemRow>
                                                    <ItemFooter>
                                                        <DangerButton onClick={() => onClickDeleteDoor(index)}>
                                                            삭제
                                                        </DangerButton>
                                                    </ItemFooter>
                                                </ItemCard>
                                            )
                                        })
                                    }
                                </ItemList>
                            </SettingInfoValue>
                        </SettingInfoBox>
                        <SettingInfoBox alignTop>
                            <SettingInfoLabel>출입문 일련번호 설정</SettingInfoLabel>
                            <SettingInfoValue style={{flexDirection: 'column', alignItems: 'flex-start'}}>
                                <Toolbar>
                                    <OutlineButton onClick={() => onClickAddDoorDevice()}>
                                        + 출입문 일련번호 추가
                                    </OutlineButton>
                                </Toolbar>
                                <ItemList>
                                    {
                                        selectClubInfo.clubDoorDeviceInfos.map((item, index)=>{
                                            return (
                                                <ItemCard key={`clubDoorDeviceInfos_${index}`}>
                                                    <ItemRow>
                                                        <ItemLabel>{'일련번호'}</ItemLabel>
                                                        <ItemField><TextInput value={item} onChange={(e) => setDoorDevice(e.target.value, index)} type="text"/></ItemField>
                                                    </ItemRow>
                                                    <ItemFooter>
                                                        <DangerButton onClick={() => onClickDeleteDoorDevice(index)}>
                                                            삭제
                                                        </DangerButton>
                                                    </ItemFooter>
                                                </ItemCard>
                                            )
                                        })
                                    }
                                </ItemList>
                            </SettingInfoValue>
                        </SettingInfoBox>
                    </ActiveSection>
                    :null
                }
                <CardFooter>
                    <SaveButton active={selectClubInfo.isDoorEdit} onClick={() => setChangeDoorInfo()}>
                        수정하기
                    </SaveButton>
                </CardFooter>
            </SettingCard>
            :null
        }
    </>
  );
};

export default React.memo(AdminClubDoorInfo);
